





















import {Component, Vue} from 'vue-property-decorator';
import News from "@/components/News.vue";

import news from "@/assets/news.json";
import Welcome from "#/welcome.md"
import Examples from "#/examples.md"

@Component({
    components: {News, Welcome: Welcome.vue.component, Examples: Examples.vue.component},
})
export default class Home extends Vue {
    private news = news;
}
